import React from 'react'

export type AgTechFadeInViewProps = {
    classes?: string
}

const AgTechFadeInView = (props: React.PropsWithChildren<AgTechFadeInViewProps>) => {
    return (
        <div className={`fading-in row-based stretched flex ${props.classes ?? ''}`}>
            {props.children}
        </div>
    )
}

export default AgTechFadeInView